import styled from "styled-components";

export const FooterMenuItems = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 64em) {
    margin-top: 20px;
  }
`;
